'use client';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Typography, useTheme } from '@mui/material';

import { ComponentBlocksQuestionList } from '@/types';

import GlobalBlockRenderer from '../GlobalBlockRenderer/GlobalBlockRenderer';

export const QuestionAnswer = (props: ComponentBlocksQuestionList) => {
  const theme = useTheme();
  return (
    <Accordion
      sx={{
        mb: 2,
        background: theme.palette.purple[800],
        p: 1.5,
        px: 2,
        borderRadius: 18,
        '&:first-of-type,&:last-of-type': {
          borderRadius: 18,
        },
        ' .MuiAccordionSummary-root': {
          borderRadius: 20,
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{ color: theme.palette.common.white }} />}
        aria-controls={`panel-${props.id}-content`}
        id={`panel-${props.id}-header`}
        sx={{
          background: theme.palette.purple[800],
          color: theme.palette.common.white,
          px: 3,
        }}
      >
        <Typography variant="h6" component="h3" fontWeight={500}>
          {props.Question}
        </Typography>
      </AccordionSummary>
      <AccordionDetails
        id={`panel-${props.id}-content`}
        sx={{
          background: theme.palette.common.white,
          py: 2,
          px: 3,
          borderRadius: 14,
          mt: 2,
          '.MuiCollapse-entered &': {
            marginBottom: 0.5,
          },
        }}
      >
        <GlobalBlockRenderer content={props.Answer || []} />
      </AccordionDetails>
    </Accordion>
  );
};
